import { createCanvas, isCanvas } from '../utils/canvas';
import { loadImage } from '../utils/image';
import { chunkWebglComposite } from './ChunkWebglFilter';
import { newBlurFilterRun } from './MTIKBlurWebglFilter';

/**
 * 获取抠图结果
 * @param width 图片宽度
 * @param height 图片高度
 * @param image 原图image对象/canvas对象
 * @param imageMask mask图对象/canvas对象
 * @param useBlurFilterRun 是否开启前景抠图
 * @param removeForeground 移除前景
 */
export async function getImageMattingResult({
    width,
    height,
    image,
    maskImage,
    chunkSize,
    useBlurFilterRun,
    foregroundEstimateImageURL,
    foregroundEstimateImage,
    removeForeground,
}: {
    width: number;
    height: number;
    image: HTMLCanvasElement | HTMLImageElement;
    maskImage: HTMLCanvasElement | HTMLImageElement;
    useBlurFilterRun: boolean;
    chunkSize?: number;
    foregroundEstimateImageURL?: string;
    foregroundEstimateImage?: HTMLCanvasElement | HTMLImageElement;
    removeForeground?: boolean;
}) {
    let foregroundEstimateImageObj = foregroundEstimateImage;

    if (!foregroundEstimateImageObj && foregroundEstimateImageURL) {
        foregroundEstimateImageObj = await loadImage(foregroundEstimateImageURL);
    }

    // ATTENTION: 有前景估计图时，拿前景估计图作为原图来抠图
    const mattingImage = foregroundEstimateImageObj || image;

    /**
     * 移除前景
     * 只会和原图做融合，不和前景估计图做融合
     */
    if (removeForeground) {
        const imageCanvas = isCanvas(image) ? image : createCanvas(width, height);
        const ctx = imageCanvas.getContext('2d')!;

        if (!isCanvas(image)) {
            ctx.drawImage(image, 0, 0, width, height);
        }

        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.drawImage(maskImage, 0, 0, width, height);

        return imageCanvas;
    }

    /**
     * foregroundEstimateImageObj：有前景估计图直接融合，不再走本地前景优化
     * useBlurFilterRun：是否走本地前景优化，优先级降低
     */
    if (foregroundEstimateImageObj || !useBlurFilterRun) {
        console.log('不开启前景抠图');

        const imageCanvas = isCanvas(mattingImage) ? mattingImage : createCanvas(width, height);
        const ctx = imageCanvas.getContext('2d')!;

        if (!isCanvas(mattingImage)) {
            ctx.drawImage(mattingImage, 0, 0, width, height);
        }

        ctx.globalCompositeOperation = 'destination-in';
        // WHY: 为什么需要 beginPath
        ctx.beginPath();
        ctx.drawImage(maskImage, 0, 0, width, height);

        return imageCanvas;
    }

    if (chunkSize && (width > chunkSize || height > chunkSize)) {
        console.log('分块前景抠图');
        return chunkWebglComposite(image, maskImage);
    }

    console.log('前景抠图');
    return newBlurFilterRun(width, height, mattingImage, maskImage);
}
